module.exports = __webpack_public_path__ + "static/amarok-aventura-8d7911a0445410759922cd59c616e6f0.png";